module.exports = __webpack_public_path__ + "static/media/blog4.5de2130f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/examples/blog4.jpg
// module id = 662
// module chunks = 0